<div
    [class.mobileWidgetViewWrap]="isDeviceMobile$ | async"
    [class.tabletWidgetViewWrap]="isDeviceTablet$ | async"
    [class]="classes?.['menu-wrapper']"
    [id]="getWidgetId"
>
    <div
        *ngIf="isLogo"
        [class.mobileWidgetViewElement]="isDeviceMobile$ | async"
        [class.tabletWidgetViewElement]="isDeviceTablet$ | async"
        [class]="classes?.['menu-logo']"
    >
        <img *ngIf="!uploadImage" src="{{ image }}" />
        <img
            *ngIf="uploadImage"
            [src]="logoImageSrc"
            [spFallbackImage]="logoImageFallbackSrc"
            alt="{{ uploadImage.alt }}"
        />
    </div>
    <div
        [class.mobileWidgetViewElement]="isDeviceMobile$ | async"
        [class.tabletWidgetViewElement]="isDeviceTablet$ | async"
        [class]="classes?.['menu-list-wrapper']"
    >
        <ul
            [class.mobileWidgetViewElement]="isDeviceMobile$ | async"
            [class.tabletWidgetViewElement]="isDeviceTablet$ | async"
            [class]="classes?.['menu-list']"
        >
            <li class="sp-ui-text" *ngFor="let menuItem of menuList">
                <span *ngIf="menuItem.isVisible">
                    <a class="menu-item" [class]="animationClass">
                        {{ menuItem.name }}
                        <div *ngIf="getVisibleSubmenuItemList(menuItem)" class="caret-icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="7"
                                viewBox="0 0 12 7"
                                fill="none"
                            >
                                <path d="M6 6.5L11.1962 0.5H0.803848L6 6.5Z" fill="currentColor" />
                            </svg>
                        </div>
                    </a>
                </span>

                <ul *ngIf="getVisibleSubmenuItemList(menuItem)" class="dropdown-submenu-list">
                    <li class="sp-ui-text" *ngFor="let submenuItem of menuItem.submenuList">
                        <span *ngIf="submenuItem.isVisible">
                            <a>
                                {{ submenuItem.name }}
                            </a>
                        </span>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
    <div
        class="mobile-icon"
        [class.mobileWidgetViewElement]="isDeviceMobile$ | async"
        [class.tabletWidgetViewElement]="isDeviceTablet$ | async"
        [class]="classes?.['mobile-icon']"
        [ngClass]="{
            'sm-icon': iconSize === ESize.S,
            'md-icon': iconSize === ESize.M,
            'lg-icon': iconSize === ESize.L,
        }"
    >
        <div
            class="mobile-icon-lines"
            [class.mobileWidgetViewElement]="isDeviceMobile$ | async"
            [class.tabletWidgetViewElement]="isDeviceTablet$ | async"
            [class]="classes?.['mobile-icon-lines']"
        ></div>
    </div>
</div>
